import './styles.scss'

import React from 'react'
import PropTypes from 'prop-types'

const TILE_SIZE = 256

function latLng2World ({ lat, lng }) {
  const sin = Math.sin((lat * Math.PI) / 180)
  const x = lng / 360 + 0.5
  let y = 0.5 - (0.25 * Math.log((1 + sin) / (1 - sin))) / Math.PI

  y =
    y < -1 // eslint-disable-line
      ? -1
      : y > 1
      ? 1
      : y
  return { x, y }
}

function world2Screen ({ x, y }, zoom) {
  const scale = Math.pow(2, zoom)
  return {
    x: x * scale * TILE_SIZE, // TILE_SIZE = 256,
    y: y * scale * TILE_SIZE
  }
}

function coordDiffInPixels (coords1, coords2, zoom) {
  const pixels1 = world2Screen(latLng2World({ lat: coords1.lat, lng: coords1.lng }), zoom)
  const pixels2 = world2Screen(latLng2World({ lat: coords2.lat, lng: coords2.lng }), zoom)

  return {
    x: pixels2.x - pixels1.x,
    y: pixels2.y - pixels1.y
  }
}

function pixelRadius (lat, lng, radius, zoom) {
  const latDiff = (1 * radius) / 110.574
  const lngDiff = (1 * radius) / (111.32 * Math.cos(lat * 0.01745329252))

  const pixelDiff = coordDiffInPixels({ lat, lng }, { lat: lat + latDiff, lng: lng + lngDiff }, zoom)

  const averageRadius = (Math.abs(pixelDiff.x) + Math.abs(pixelDiff.y)) / 2

  return Math.floor(averageRadius)
}

const Circle = ({
  lat,
  lng,
  radius,
  top,
  left,
  mapState,
  hide,
  alwaysCentered,
  mapState: { width, height },
  zIndex,
  toGoogleMap
}) => {
  if (typeof left === 'undefined' || typeof top === 'undefined') {
    return null
  }

  const pixels = pixelRadius(lat, lng, radius, mapState.zoom)
  let topRate = -pixels
  let leftRate = -pixels

  if (!toGoogleMap) {
    topRate = alwaysCentered ? -pixels + (height - 4) / 2 : -pixels + Math.round(top * 1000) / 1000
    leftRate = alwaysCentered ? -pixels + (width - 4) / 2 : -pixels + Math.round(left * 1000) / 1000
  }

  return (
    <div
      className={`map-location-pulsate${hide ? ' hidden' : ''}`}
      style={{
        width: pixels * 2,
        height: pixels * 2,
        borderRadius: pixels,
        top: topRate,
        left: leftRate,
        zIndex: hide ? 1 : zIndex
      }}
    />
  )
}

Circle.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  radius: PropTypes.number.isRequired,
  top: PropTypes.number,
  left: PropTypes.number,
  zIndex: PropTypes.number,
  hide: PropTypes.bool,
  toGoogleMap: PropTypes.bool,
  alwaysCentered: PropTypes.bool,
  mapState: PropTypes.object
}

export default Circle
